// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_QOG","cls2":"SimplePaperPodcast-cls2_3ZX SimplePaperPodcast-cls1_QOG"};